import PropTypes from 'prop-types';
import { forwardRef, useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Chip, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { AuthContext } from '../../../contextAPI/ContextAPI';
import { createBrowserHistory } from 'history';
import rightArrowIcon from "../../../../icons/sidebar/rightArrowIcon.svg"
import rightArrowIconFadeColor from "../../../../icons/sidebar/rightArrowIconFadeColor.svg"

// project import
// import { activeItem } from 'store/reducers/menu';

// ==============================|| NAVIGATION - LIST ITEM ||============================== //

const NavItem = ({ item, level }) => {
  const history = createBrowserHistory();
  const theme = useTheme();
  const { auth, setAuth } = useContext(AuthContext)

  const dispatch = true
  const { pathname } = useLocation();

  // const { drawerOpen, openItem } = true;
  const drawerOpen = true;
  const openItem = ["dashboard", "usermanagement", "visitmanagement"];

  let itemTarget = '_self';
  // if (!item.target) {
  //   itemTarget = '_blank';
  // }

  let listItemProps = { component: forwardRef((props, ref) => <Link ref={ref} {...props} to={item.url} target={itemTarget} />) };
  if (item?.external) {
    listItemProps = { component: 'a', href: item.url, target: itemTarget };
  }

  const itemHandler = (id) => {
    // dispatch(activeItem({ openItem: [id] }));
  };
// rs sidebar
  const Icon = item.icon;
  const itemIcon = item.icon ? <Icon style={{ fontSize: drawerOpen ? '1rem' : '1.25rem' }} /> : false;

  //   const isSelected = openItem.findIndex((id) =>{

  // // console.log("checkid", history.location.pathname)
  //   return  item.url ===  history.location.pathname
  //   }) > -1;

  const isSelected = pathname === item.url;

  // active menu item on page load
  useEffect(() => {
    if (pathname.includes(item.url)) {
      // dispatch(activeItem({ openItem: [item.id] }));
    }
    // eslint-disable-next-line
  }, [pathname]);

  const textColor = 'black';
  const iconSelectedColor = 'primary.main';

  return (
    <ListItemButton
      {...listItemProps}
      disabled={item.disabled}
      onClick={() => itemHandler(item.id)}
      selected={isSelected}
      sx={{
        zIndex: 1201,
        pl: drawerOpen ? `${level * 28}px` : 1.5,
        py: !drawerOpen && level === 1 ? 1.25 : 1,
        backgroundColor: isSelected ? "#87CEEB" : "transparent",
        // borderBottom: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 4,
        '&.Mui-selected': {
          backgroundColor: "#87CEEB",
          borderRight: `5px solid ${"#3488a9ff"}`,
          // borderBottom: `1px solid ${theme.palette.primary.main}`,
          color: iconSelectedColor,
          borderRadius: 4,
          '&:hover': {
            backgroundColor: "#87CEEB",
            color: iconSelectedColor,
            borderRadius: 4
          }
        },
        '&:hover': {
          backgroundColor: isSelected ? "#87CEEB" : "#87CEEB"
        }
      }}
    >
      {itemIcon && (
        <ListItemIcon
          sx={{
            minWidth: 28,
            color: isSelected ? iconSelectedColor : textColor,
            ...(!drawerOpen && {
              borderRadius: 1.5,
              width: 36,
              height: 36,
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                // bgcolor: 'secondary.lighter'
              }
            }),
            ...(!drawerOpen &&
              isSelected && {
              bgcolor: 'primary.lighter',
              '&:hover': {
                bgcolor: 'primary.lighter'
              }
            })
          }}
        >
          {itemIcon}
        </ListItemIcon>
      )}
      {(drawerOpen || (!drawerOpen && level !== 1)) && (
        <ListItemText
          primary={
            <Typography sx={{ marginLeft: "8px", color: isSelected ? "rgb(0, 0, 0)" : "rgb(0, 0, 0)", fontSize: "14px", fontWeight: 500 }}>
              {item.title} <span style={{float:"right"}}><img src={rightArrowIconFadeColor} alt=">" height={"18"} width={"18"} /></span>
            </Typography>
          }

        />
      )}
      {(drawerOpen || (!drawerOpen && level !== 1)) && item.chip && (
        <Chip
          color={item.chip.color}
          variant={item.chip.variant}
          size={item.chip.size}
          label={item.chip.label}
          avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
        />
      )}
    </ListItemButton>
  );
};

NavItem.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number
};

export default NavItem;
